export default {
  TN_CREDITCARD_TYPE_MISMATCH_EXCEPTION: 'The credit card type and credit card number you provided do not match. Please review your payment information and try submitting your order again.',
};
